export const SCROLL_TRIGGER = 123;
export const SHOW_ENTER_FORM_MESSAGE =
    'Зарегистрируйтесь и получите доступ к разделам "Избранное" и "Сравнение", что позволит удобно сравнивать и сохранять понравившиеся объявления';